import { render, staticRenderFns } from "./caregiverIndex.vue?vue&type=template&id=4cfd1587&scoped=true"
import script from "./caregiverIndex.vue?vue&type=script&lang=js"
export * from "./caregiverIndex.vue?vue&type=script&lang=js"
import style0 from "./caregiverIndex.vue?vue&type=style&index=0&id=4cfd1587&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfd1587",
  null
  
)

export default component.exports